<template>
  <div class="protests" id="protests-section">
       <h3 class="content__title content__title--contrast">Bądź częścią pysznej zmiany!</h3>
    <div class="protests__intro content__text">
      <span>
        Czujesz potrzebę zmian? Brak Ci nadziei? Chcesz działać na rzecz klimatu i sprawiedliwego społeczeństwa i szukasz na to… przepisów? To książka dla Ciebie!
      </span>
      <br /><br />
      <span>
        Pogadajmy o lepszej Polsce przy lepszym jedzeniu. Zapraszamy do wspólnego stołu!
      </span>
      <br /><br />
    </div>

    <div class="protests__slider">
    <SliderProtests />
    </div>
  </div>
</template>

<script>
import SliderProtests from "../elements/SliderProtests";
export default {
  name: "Protests",
  components: {
    SliderProtests,
  },
   inject: ['content'],
};
</script>
